import styled from 'styled-components';
import * as colors from '@styles/colors';

export const BlockTitle = styled('div')`
  margin-bottom: 24px;
  font-size: 40px;
  color: ${colors.primary80};
  color: orange;
`;
